import React, { ReactElement } from "react";
import { gql, useQuery } from "urql";
import stableStringify from "json-stable-stringify";
import { useParams } from "wouter";

import { isValidMongoDBObjectID } from "../../../common/src/utils";

const DOCS = gql`
    query docs($filter: PriceFilterInput) {
        docs: prices(filter: $filter) {
            _id
            instrumentId
            instrument {
                name
            }
            date
            cleanPrice
            accruedInterest
            cleanPrice
            currency
            type
            createTimestamp
            updateTimestamp
            versions
            updateUserInfo {
                name
            }
        }
    }
`;

export const PricePage = (): ReactElement => {
    const params = useParams<{ id: string }>();
    let id = "000000000000000000000000";
    if (isValidMongoDBObjectID(params.id)) {
        id = params.id;
    }
    const [{ fetching, error, data }] = useQuery({ query: DOCS, variables: { filter: { idIn: id } } });
    if (fetching) return <p>Loading</p>;
    if (error) return <p>error: {JSON.stringify(error, null, 2)}</p>;

    if (!isValidMongoDBObjectID(params.id)) {
        return <p>error: not a valid objectId</p>;
    }

    return <pre>{stableStringify(data.docs, { space: "  " })}</pre>;
};
